<template>
    <div class="kimsa-segmented" :class="{ 'kimsa-segmented--scrollable': scrollable, 'kimsa-segmented--dense': dense }"
        :style="scrollable ? null : `grid-template-columns: repeat(${columns || items.length}, 1fr)`">
        <button type="button" v-for="item in items" :key="item[itemValue]" class="segment-opt"
            :class="{ 'segment-opt--active': value === item[itemValue] }" @click="$emit('change', item[itemValue])">
            {{ item[itemText] }}
        </button>
    </div>
</template>

<script>
export default {
    name: "KimsaSegmented",
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        value: {
            type: [String, Number, Boolean],
            default: null,
        },
        itemText: {
            type: String,
            default: 'name',
        },
        itemValue: {
            type: String,
            default: 'value',
        },
        columns: {
            type: [String, Number],
            default: null,
        },
        scrollable: {
            type: Boolean,
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped>
.kimsa-segmented {
    display: grid;
    gap: 8px;
}

.kimsa-segmented--scrollable {
    display: flex;
    gap: 6px;
    overflow-x: auto;
    scrollbar-width: none;
}

.kimsa-segmented--scrollable::-webkit-scrollbar {
    display: none;
}

.kimsa-segmented--scrollable .segment-opt {
    flex: 0 0 auto;
    white-space: nowrap;
}

.kimsa-segmented--dense .segment-opt {
    padding: 6px 12px;
    border-radius: 8px;
    font-size: 12px;
}

.segment-opt {
    padding: 12px 16px;
    border-radius: 9px;
    border: 1.5px solid var(--v-outline-base);
    background: var(--v-field-base);
    font-family: inherit;
    font-size: 14px;
    font-weight: 500;
    color: var(--v-txtSecondary-base);
    cursor: pointer;
    text-align: center;
    transition: border-color .15s ease, background-color .15s ease, color .15s ease;
}

.segment-opt:hover {
    border-color: var(--v-secondary-base);
    color: var(--v-accent-base);
}

.segment-opt--active {
    border-color: var(--v-secondary-base);
    background: rgba(102, 204, 204, 0.12);
    color: var(--v-accent-base);
    font-weight: 600;
}

.theme--dark .segment-opt:hover {
    border-color: rgba(204, 255, 51, 0.5);
    color: var(--v-primary-base);
}

.theme--dark .segment-opt--active {
    border-color: rgba(204, 255, 51, 0.5);
    background: linear-gradient(135deg, rgba(204, 255, 51, 0.12), rgba(51, 153, 153, 0.12));
    color: var(--v-primary-base);
}
</style>
